(() => {
  const root = document.querySelector('.product-flow');
  if (!root) return;
  const form = root.querySelector('.product-form[data-product-form]');
  const mainButton = form?.querySelector('[type="submit"]');
  const sticky = root.querySelector('[data-sticky-buy]');
  const finalButton = root.querySelector('[data-flow-submit]');
  const finalLabel = finalButton?.textContent.trim() || 'Add to cart';
  const stickyButton = root.querySelector('[data-sticky-submit]');
  const nav = root.querySelector('.product-jump');
  const links = [...nav.querySelectorAll('a[href^="#"]')];
  const targets = links.map(a => root.querySelector(a.getAttribute('href'))).filter(Boolean);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  finalButton?.addEventListener('click', () => { if (form && !mainButton.disabled) form.requestSubmit(mainButton); });
  if (mainButton) {
    const syncButtons = () => [stickyButton, finalButton].filter(Boolean).forEach(button => {
      button.disabled = mainButton.disabled;
      button.textContent = mainButton.disabled ? mainButton.textContent : (button === finalButton ? finalLabel : 'Add to cart');
    });
    new MutationObserver(syncButtons).observe(mainButton, { attributes: true, childList: true, subtree: true });
    syncButtons();
    // Keep cart errors visible when the purchase form is above the viewport.
    const status = document.createElement('p'); status.className = 'flow-add-status'; status.setAttribute('role', 'alert'); status.hidden = true; root.append(status);
    new MutationObserver(() => {
      const error = form.querySelector('[data-cart-error]');
      const offscreen = form.getBoundingClientRect().bottom < 0;
      status.hidden = !error || error.hidden || !offscreen;
      status.textContent = status.hidden ? '' : error.textContent;
    }).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }
  root.querySelectorAll('[data-addon-select]').forEach(select => select.addEventListener('change', () => {
    select.closest('.upsell-card').querySelector('[data-addon-price]').textContent = select.selectedOptions[0].dataset.price;
  }));
  const primaryPrice = root.querySelector('[data-product-price]');
  const finalPrice = root.querySelector('[data-flow-final-price]');
  if (primaryPrice && finalPrice) {
    const syncPrice = () => { finalPrice.textContent = primaryPrice.textContent; };
    new MutationObserver(syncPrice).observe(primaryPrice, { childList: true, subtree: true, characterData: true });
    syncPrice();
  }
  let scheduled = false;
  const updateActive = () => {
    scheduled = false;
    if (sticky && form) sticky.hidden = form.getBoundingClientRect().bottom > 0;
    const edge = nav.getBoundingClientRect().height + 32;
    let current = null;
    targets.forEach(target => { if (target.getBoundingClientRect().top <= edge) current = target; });
    links.forEach(link => {
      if (current && link.hash === `#${current.id}`) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(updateActive); } };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  updateActive();
  links.forEach(link => link.addEventListener('click', () => {
    const target = root.querySelector(link.hash);
    if (target) { target.tabIndex = -1; target.focus({ preventScroll: true }); }
  }));
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (!reduced.matches) entry.target.classList.add('flow-enter');
        observer.unobserve(entry.target);
      }
    }), { threshold: 0.12 });
    root.querySelectorAll('.flow-story-image, .camera-coverage, .flow-package-grid').forEach(el => observer.observe(el));
  }
  // Quick buying controls yield to open navigation and photo dialogs.
  const syncLayers = () => {
    const menuOpen = document.querySelector('[data-mobile-nav]')?.dataset.open === 'true';
    if (sticky) sticky.style.visibility = menuOpen || !!root.querySelector('dialog[open]') ? 'hidden' : '';
  };
  const menu = document.querySelector('[data-mobile-nav]');
  if (menu) new MutationObserver(syncLayers).observe(menu, { attributes: true, attributeFilter: ['data-open'] });
  root.querySelectorAll('dialog').forEach(dialog => new MutationObserver(syncLayers).observe(dialog, { attributes: true, attributeFilter: ['open'] }));
})();
